import { Link } from 'react-router-dom';
import { Reveal } from './Reveal.tsx';
import { getIcon } from '../../lib/icons.ts';
import type { FeatureItem } from '../../siteContentTypes.ts';

export function FeatureSection({
  id,
  title,
  subtitle,
  image,
  features,
  ctaText,
  ctaUrl,
  reversed,
}: {
  id?: string;
  title: string;
  subtitle: string;
  image: string;
  features: FeatureItem[];
  ctaText: string;
  ctaUrl: string;
  reversed?: boolean;
}) {
  return (
    <section id={id} style={{ padding: '56px 24px', maxWidth: 1160, margin: '0 auto' }}>
      <Reveal>
        <div
          style={{
            display: 'flex',
            flexDirection: reversed ? 'row-reverse' : 'row',
            alignItems: 'center',
            gap: 48,
            flexWrap: 'wrap',
          }}
        >
          <div style={{ flex: '1 1 320px' }}>
            <div
              style={{
                borderRadius: 24,
                background: reversed ? 'linear-gradient(135deg, #1c1b19, #3a3733)' : 'linear-gradient(135deg, var(--accent-tint), var(--surface))',
                border: '1px solid var(--border)',
                minHeight: 320,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {image ? (
                <img src={image} alt="" style={{ maxWidth: '100%', maxHeight: 320, borderRadius: 20 }} />
              ) : (
                <div style={{ color: reversed ? 'rgba(255,255,255,0.6)' : 'var(--text-tertiary)', fontSize: 13, fontWeight: 700 }}>
                  Aperçu de l'application
                </div>
              )}
            </div>
          </div>

          <div style={{ flex: '1 1 320px', display: 'flex', flexDirection: 'column', gap: 18 }}>
            <h2 style={{ fontSize: 28, fontWeight: 800, margin: 0 }}>{title}</h2>
            <p style={{ fontSize: 15, color: 'var(--text-secondary)', margin: 0 }}>{subtitle}</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
              {features.map((f) => {
                const Icon = getIcon(f.icon);
                return (
                  <div key={f.text} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Icon size={16} color="var(--accent-dark)" />
                    <span style={{ fontSize: 13.5, fontWeight: 600 }}>{f.text}</span>
                  </div>
                );
              })}
            </div>
            <Link to={ctaUrl} className="btn btn-primary" style={{ width: 'auto', padding: '12px 22px', marginTop: 8 }}>
              {ctaText}
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
